import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { User, Lock } from "react-feather";
import userImage from "../../assets/images/users/user2.jpg";

const roleConfig = {
  "1": {
    profileLink: "/Profile/ProfileUpdate",
    passwordLink: "/Admin/ChangesPasswordAd"
  },
  "2": {
    profileLink: "/Profile/UpdateProfileBusiness",
    passwordLink: "/Admin/ChangesPasswordAd"
  },
  "3": {
    profileLink: "/Profile/ProfileUpdateMD",
    passwordLink: "/MasterDistributor/ChangePasswordMd"
  },
  "4": {
    profileLink: "/Profile/UpdateProfileSD",
    passwordLink: "/SuperDistributor/ChangePasswordSP"
  },
  "5": {
    profileLink: "/Profile/UpdateProfileDistributor",
    passwordLink: "/Distributor/ChangePasswordDistributer"
  },
  "6": {
    profileLink: "/Profile/UpdateProfileAgent",
    passwordLink: "/Agent/ChangePassword"
  }
};

const ProfileDD = () => {
  const { user: currentUser } = useSelector((state) => state.user);
  const config = roleConfig[currentUser.role];

  return (
    <Fragment>
      <div className="logout-header">
        <img src={userImage} alt="user" />
        <span>{currentUser.firstName}</span>
      </div>

      {config && (
        <div className="loguot-body">
          <Link to={config.profileLink}>
            <User size={20} />
            <span>My Profile</span>
          </Link>
          <Link to={config.passwordLink}>
            <Lock size={20} />
            <span>Change Password</span>
          </Link>
        </div>
      )}
    </Fragment>
  );
};

export default ProfileDD;
